import clsx from "classnames";
import { Container } from "reactstrap";
import Buttons from "ui/Buttons/component";
import styles from "./styles.module.scss";
import OverlayDots from "/public/site-assets/svg/overlay-dots.svg";
import StarIcon from "/public/site-assets/svg/star.svg";

import FooterWave2Icon from "@/public/site-assets/svg/footer-wave-2.svg";

export const ImageWithTextQuote = ({
  className,
  heading,
  content,
  buttons,
  image,
  showWave = true,
  waveDirection = "down",
  waveColor = "yellow",
  waveBackground = "primary",
  showTopWave,
  topWaveDirection,
  topWaveColor,
  topWaveBackground,
}) => {
  return (
    <>
      {showTopWave && (
        <div
          className={clsx(
            "footer",
            topWaveDirection === "down" && "rotate",
            topWaveColor,
            topWaveBackground,
          )}
          style={{ marginBottom: "-1px", zIndex: 1, position: "relative" }}
        >
          <FooterWave2Icon />
        </div>
      )}
      <section className={clsx(className, styles.root)}>
        <Container>
          <div className="position-relative">
            <div className={`wrapper`}>
              <div className="position-relative z-index-1">
                {heading && <h3 className="h3">{heading}</h3>}
                {content && (
                  <div className={`content py-4`} dangerouslySetInnerHTML={{ __html: content }} />
                )}
                {buttons && (
                  <Buttons buttons={buttons} className="d-flex align-items-center text-center" />
                )}
                <div className="overlay-dots position-absolute">
                  <OverlayDots />
                </div>
              </div>
              <div className="position-relative pe-lg-5">
                <span className="floating-icons">
                  <StarIcon />
                </span>
                <span className="floating-icons">
                  <StarIcon />
                </span>
                {image && (
                  <img className={`position-relative z-index-1`} src={image.url} alt={image.alt} />
                )}
                <div className="overlay-dots position-absolute">
                  <OverlayDots />
                </div>
              </div>
            </div>
          </div>
        </Container>
      </section>
      {showWave && (
        <div
          className={clsx(
            "footer",
            waveDirection === "down" && "rotate",
            waveColor,
            waveBackground,
          )}
          style={{ marginTop: "-1px" }}
        >
          <FooterWave2Icon />
        </div>
      )}
    </>
  );
};

export default ImageWithTextQuote;
